import React, { FC, useState } from "react";
import { LocalizationProvider, MobileTimePicker, MobileTimePickerProps } from "@mui/x-date-pickers";
import { validateInput } from "../../utils/validators/Validators";

import "./styles.css";
import { Dayjs } from "dayjs";
import { FormValidators } from "../Form";
import { TextField, useTheme } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import 'dayjs/locale/de';
import strings from "common/Translation/Translate";
import 'dayjs/locale/pt';
import 'dayjs/locale/en';
import { useSelector } from "react-redux";
import { defaultLanguage } from "utils/redux/reducer/authentication-slice";
import Paragraph from "components/Typography/Typography";

interface OwnProps {
  field?: string;
  disabled?: boolean;
  placeholder?: string;
  autoFocus?: boolean;
  typeValue?: string;
  textChange: (
    value: string,
    field: string,
    error?: { error: boolean; message: string }
  ) => void;
  validators?: FormValidators[];
  hasError?: boolean;
  fieldError?: string | boolean;
  label?: string;
  disableFuture?: boolean;
  minDate?: any;
  size?: any;
  sx?: any;
}

const TimeInput: FC<OwnProps & MobileTimePickerProps<any, any>> = ({
  hasError,
  validators,
  textChange,
  field,
  value,
  placeholder,
  fieldError,
  disabled,
  disableFuture,
  minDate,
  label,
  typeValue,
  size,
  sx,
  ...rest
}) => {
  const theme = useTheme();
  const selectedlangLocaleCode = useSelector(defaultLanguage).value.split('_')[0]
  const [error, setError] = useState<{
    error: boolean;
    message: string;
  } | null>(null);
  const handleChange = (value: Dayjs | null) => {
    if (value) {
      const inputError = validateInput(
        validators as FormValidators[],
        value as any
      );
      textChange(
        value as any,
        field as string,
        inputError
      );
      setError(inputError);
    }
  };

  const handleOnAccept = (value: any) => {
    if (value) {
      // onAccept(value)
    }
  }
  const customMessage = () => !error && (hasError && fieldError) ? strings.requiredField : ''
  return (
    <>
      {label ? <Paragraph sx={{ fontSize: '0.75rem', marginBottom: '6px' }}>{label}</Paragraph> : null}
      <LocalizationProvider adapterLocale={selectedlangLocaleCode} dateAdapter={AdapterDayjs}>
        <MobileTimePicker
          {...rest}
          // label={<ToolTip title={label}><div>{label}</div></ToolTip>}
          onAccept={handleOnAccept}
          value={value}
          onChange={(newValue: Dayjs | null) => handleChange(newValue)}
          disabled={disabled}
          className={`input-field ${fieldError}`}
          OpenPickerButtonProps={{ color: "primary" }}
          shouldDisableTime={(timeValue, clockType) => {
            if (clockType === 'minutes' && timeValue % 30) {
              return true;
            }
            return false;
          }}
          renderInput={(params) => (
            <TextField {...params}
              size={size}
              helperText={error && error.error ? error.message : customMessage()}
              sx={{
                width: '100%',
                "& fieldset.MuiOutlinedInput-notchedOutline": {
                  borderColor: theme.palette.secondary.main,
                  borderRadius: "0%",
                },
                ".MuiInputBase-root": {
                  backgroundColor: "white",
                  height: '39px'
                },
                '.MuiInputBase-root.Mui-disabled, .MuiInputBase-input.Mui-disabled': {
                  backgroundColor: '#E7E7E7',
                  borderRadius: 0,
                  borderColor: '#9B9B9B',
                  color: '#151515'
                },
                ...sx,
              }}
              error={((error && error.error) || (!error && hasError && fieldError)) ? true : false}
            />
          )}
        />
      </LocalizationProvider>
    </>
  );
};

export default TimeInput;
